import { useEffect, useState } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import blogApi from "../../apis/blogApi";
import DOMPurify from "dompurify";
import parse from "html-react-parser";

import "./singleBlog.css";
import { Container } from "react-bootstrap";

const SingleBlog = () => {
  const [blog, setBlog] = useState({});
  const [content, setContent] = useState("");
  const location = useLocation();
  const path = location.pathname.split("/")[2];
  const navigate = useNavigate();

  useEffect(() => {
    const getBlog = async () => {
      try {
        const res = await blogApi.getABlog(path);
        if (res) {
          setBlog(res);
          setContent(res.content || "");
        }
      } catch (err) {
        console.error("Failed to fetch blog:", err);
      }
    };
    getBlog();
  }, [path]);

  const cleanHTML = DOMPurify.sanitize(content, {
    USE_PROFILES: { html: true },
  });

  const handleOnEdit = () => {
    navigate(`/blog/edit/${path}`);
  };

  return (
    <Container className="single-blog">
      <div className="single-blog-button">
        <button onClick={() => navigate(`/blog`)} className="back-button">
          &lt; Back to blogs list
        </button>
      </div>
      <div className="single-blog-wrapper">
        {blog.image && (
          <img
            src={blog.image}
            alt={blog.title || "Blog image"}
            className="single-blog-image"
          />
        )}
        <h1 className="single-blog-title">
          {blog.title}
          <div className="single-blog-edit">
            <i
              className="far fa-edit single-blog-icon"
              onClick={handleOnEdit}
            ></i>
          </div>
        </h1>
        <div className="single-blog-info">
          <span className="single-blog-author">
            By: <b>{blog.authorName || "Unknown"}</b> |{" "}
            {blog.createdAt && <i className="far fa-calendar"></i>}{" "}
            {blog.createdAt && new Date(blog.createdAt).toDateString()}
          </span>
        </div>
        <div className="single-blog-content">{parse(cleanHTML)}</div>
      </div>
    </Container>
  );
};

export default SingleBlog;
